import { AbstractControl, ValidationErrors } from '@angular/forms';

export function whiteSpacesValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  const isOnlyWhitespace = value.length && value.trim().length === 0;

  return isOnlyWhitespace ? { whiteSpaces: true } : null;
}
